import { useEffect, useState } from 'react';
import InfoTooltip from '../components/InfoTooltip/Info-tooltip';

export const useTutorialOverlay = ({
  className = '',
  isTooltipIconVisible,
  isTutorialShown,
  tooltipClassname = '',
  tooltipsArray,
  onCloseTutorial,
}: {
  className?: string;
  isTooltipIconVisible: boolean;
  isTutorialShown: boolean;
  tooltipClassname: string;
  tooltipsArray: (string | JSX.Element)[];
  onCloseTutorial(): void;
}) => {
  const [isTutorialVisible, setIsTutorialVisible] = useState(isTutorialShown);
  const [currentStep, setCurrentStep] = useState(isTutorialShown ? 0 : -1);

  useEffect(() => {
    setIsTutorialVisible(isTutorialShown);
    setCurrentStep(isTutorialShown ? 0 : -1);
  }, [isTutorialShown]);

  const isLastStep = currentStep === tooltipsArray.length - 1;

  const goToNextStep = () => setCurrentStep(currentStep + 1);

  const closeTutorial = () => {
    onCloseTutorial();
    setIsTutorialVisible(false);
    setCurrentStep(-1);
  };

  const tooltips = tooltipsArray.map(
    (content, i) =>
      ({
        className,
        tooltipClassname,
        tooltipPopupClassname,
      }: {
        className?: string;
        tooltipClassname?: string;
        tooltipPopupClassname?: string;
      }) =>
        (
          <InfoTooltip
            key={`info_tooltip_hook_${i}`}
            tooltipClassname={tooltipClassname}
            content={content}
            isTooltipIconVisible={isTooltipIconVisible}
            isTooltipVisible={currentStep === i}
            tooltipPopupClassname={tooltipPopupClassname}
          />
        )
  );

  const TutorialOverlay = () => (
    <div
      className={`
        ${className}
        fixed
        top-0
        left-0
        w-screen
        h-screen
        z-80
        ${isTutorialVisible ? 'block' : 'hidden'}
      `}
    >
      <div className="absolute top-0 left-0 w-full h-full opacity-75 bg-white dark:bg-black" />
      <div className="absolute bottom-0 left-0 flex justify-center items-center w-full h-28 bg-primary">
        <div className="flex justify-center items-center gap-8">
          <span
            className={'font-bold text-black dark:text-black cursor-pointer'}
            onClick={closeTutorial}
          >
            {isLastStep ? 'Close tutorial' : 'Skip'}
          </span>

          {!isLastStep && (
            <span
              className={'font-bold text-black dark:text-black cursor-pointer'}
              onClick={goToNextStep}
            >
              Next
            </span>
          )}
        </div>
      </div>
    </div>
  );

  return { TutorialOverlay, tooltips };
};
